import styled from 'styled-components';
import composition1 from '../../assets/composition1.png';
import composition2 from '../../assets/composition2.png';
import composition3 from '../../assets/composition3.png';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { lightTheme } from '../../styles/theme';
import { ButtonWrap } from '../FinalizeSubscription';
import { useTranslation } from '../../lang/TranslationContext';
import { HASH_ROUTES } from '../../constants/routes';

export const Download = () => {
	const { width } = useWindowDimensions();
	const { translations } = useTranslation();

	const composition =
		width > 1200 ? composition1 : width > 800 ? composition2 : composition3;

	return (
		<Wrap>
			<InnerWrap>
				<div>
					<img src={composition} alt="composition" />
				</div>
				<section>
					<p>{translations.landing.download}</p>
					<ButtonWrap>
						<div>
							<i className="pi pi-apple" />
							<div>
								<p>Soon available</p>
								<p>For MacOS</p>
							</div>
						</div>
						<div id={HASH_ROUTES.pricing}>
							<i className="pi pi-microsoft" id="microsoft" />
							<div>
								<p>Soon available</p>
								<p>For Windows</p>
							</div>
						</div>
					</ButtonWrap>
				</section>
			</InnerWrap>
		</Wrap>
	);
};

const Wrap = styled.div`
	display: flex;
	justify-content: center;
	width: 100%;
	background: #fff;
`;

const InnerWrap = styled.div`
	max-width: 1440px;
	margin: 100px 0;
	display: flex;
	flex-direction: column;
	align-items: center;

	> div {
		width: 100%;

		img {
			width: 100%;
		}
	}

	> section {
		display: flex;
		flex-direction: column;
		align-items: center;
		pointer-events: none;

		> p {
			text-align: center;
			max-width: 580px;
			font-weight: 400;
			font-size: 16px;
			color: ${lightTheme.typography.tetriary};
			margin-bottom: 25px;
			padding: 0 15px;
		}
	}
`;
